<h2 class="header" (click)="toggle()">{{ model?.name }}</h2>

<div class="elements">
	<stream-element-container class="elements-entry" *ngFor="let element of model?.elements" [model]="element" (update)="update($event)"></stream-element-container>
</div>
